<div class="bg-black container border-radius-10">
  <div class="d-flex justify-content-center">
    <img src="public/success-icon.png" alt="" class="mt-5" />
  </div>

  <div class="align-items-center text-center mt-4 mb-5">
    <div class="fs-18 fw-normal">Member Enrolled Successfully!</div>
    <div class="fs-14 fw-normal mt-2">
      Thank you! The membership has been activated and the member
      <div class="d-flex justify-content-center">
        is now part of the
        <div class="fw-bold ms-2">
          {{ activeEnrollment?.classDetails?.ClassName }}
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex text-center justify-content-center">
    <div class="card bg-card font-white mb-5 border-radius-10">
      <div class="p-3 row align-items-center">
        <div class="d-flex gap-2 align-items-center col-md-6 col-12">
          <div><img src="public/gold-badge.png" alt="Gold Badge" /></div>
          <div>
            <div class="fs-16 fw-bold">
              {{ studentData?.FirstName }} {{ studentData?.LastName }}
            </div>
            <div class="fs-14 fw-normal text-start">ID: {{ studentData?.StudentID }}</div>
          </div>
        </div>
        <div class="col-md-6 col-12 d-flex justify-content-end align-items-center">
          <button 
          class="download-btn-minimal font-white cursor-pointer fs-14 border-radius-10 fw-medium d-inline-flex align-items-center gap-2 bg-none py-1 px-2"
          (click)="downloadReceipt()">
          <div [innerHTML]="SVG_ICONS.DOWNLOAD_ICON() | sanitizer : 'html'"></div>
          Download Receipt
        </button>
        </div>
      </div>
      <hr />

      <div>
        <div class="row mx-3 my-3 text-start">
          <!-- Membership Plan -->
          <div class="col-lg-2 col-md-6 mt-1 mb-1 col-12">
            <div class="fs-12 fw-bold">Membership Plan</div>
            <div class="fs-14 fw-normal">
              {{ activeSubscription?.packageDetails?.PackageName }}
            </div>
          </div>
        
          <!-- Start Date -->
          <div class="col-lg-2 col-md-6 mt-1 mb-1 col-12">
            <div class="fs-12 fw-bold">Start Date</div>
            <div class="fs-14 fw-normal">
              {{ activeSubscription?.StartDate | date: "dd-MM-yy" }}
            </div>
          </div>
        
          <!-- Transaction ID -->
          <div class="col-lg-2 col-md-6 mt-1 mb-1 col-12">
            <div class="fs-12 fw-bold">Transaction ID</div>
            <div class="fs-14 fw-normal">
              TXN{{ activeSubscription?.SubscriptionID }}
            </div>
          </div>
        
          <!-- Assigned Class -->
          <div class="col-lg-2 col-md-6 mt-1 mb-1 col-12">
            <div class="fs-12 fw-bold">Assigned Class</div>
            <div class="fs-14 fw-normal">
              {{ activeEnrollment?.classDetails?.ClassName }}
            </div>
          </div>
        
          <!-- Amount Paid -->
          <div class="col-lg-2 col-md-6 mt-1 mb-1 col-12">
            <div class="fs-12 fw-bold">Amount Paid</div>
            <div class="fs-14 fw-normal">
              ₹{{ activeSubscription?.TotalAmount }}
            </div>
          </div>
        
          <!-- Payment Mode -->
          <div class="col-lg-2 col-md-6 mt-1 mb-1 col-12">
            <div class="fs-12 fw-bold">Payment Mode</div>
            <div class="fs-14 fw-normal">UPI</div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>
